export default __webpack_public_path__ + "18920b1b780511e86a27a01c77cae5fd.png";